import CloseIcon from '@mui/icons-material/Close';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import {Button, Dialog, DialogContent, DialogTitle, IconButton, Stack, TextField, Typography} from '@mui/material';
import CopyAdornment from 'crqlar-react-common/dist/components/CopyAdornment';
import {Survey} from 'crqlar-react-common/dist/models/survey/survey.model';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {anonymousSurveyLink} from '../shared/surveyPublicLinks.util';
import {useSurveyQrLogoUrl} from './surveyQrBranding.util';
import SurveyQrFullscreenDialog from './SurveyQrFullscreenDialog';

export default function AnonymousSurveyShareDialog({open, onClose, survey}: {open: boolean; onClose: () => void; survey: Survey}) {
    const {t} = useTranslation();
    const [fullscreenQr, setFullscreenQr] = useState(false);
    const logoUrl = useSurveyQrLogoUrl(survey);
    const link = survey.id ? anonymousSurveyLink(survey.id) : '';
    return <>
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" aria-labelledby="anonymous-share-survey-title">
            <DialogTitle><Stack direction="row" alignItems="center" justifyContent="space-between">
                <Typography component="span" variant="h6">{t('Share survey')}</Typography>
                <IconButton aria-label={t('Close')} onClick={onClose}><CloseIcon/></IconButton>
            </Stack></DialogTitle>
            <DialogContent dividers><Stack gap={2.5}>
                <TextField value={link} size="small" fullWidth InputProps={{readOnly: true, endAdornment: <CopyAdornment value={link}/>}}/>
                <Button size="small" startIcon={<QrCode2Icon/>} sx={{alignSelf: 'flex-start'}} onClick={() => setFullscreenQr(true)}>{t('QR code')}</Button>
                <Typography variant="caption" color="text.secondary">{t('The link is permanent - guests always get the latest published version.')}</Typography>
            </Stack></DialogContent>
        </Dialog>
        <SurveyQrFullscreenDialog open={open && fullscreenQr} onClose={() => setFullscreenQr(false)} value={link} surveyName={survey.name} logoUrl={logoUrl}/>
    </>;
}
